module.exports = __webpack_public_path__ + "static/media/scan-icon.6f8d4f73.svg";